import g from '#core/global';
import events from '#core/events';
import load from '#core/load';


const duo_$ = '.dynamic-duo';
const item_attr = 'data-dynamic-duo-item';
const trigger_attr = 'data-dynamic-duo-trigger';
const selector_attr = 'data-dynamic-duo-selector';
const item_$ = `[${item_attr}]`;
const trigger_$ = `[${trigger_attr}]`;

let has_dynamic_duo = false;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('dynamic-duo')) return false;

		load.content(() => {
			has_dynamic_duo = assign_elements();
			if (!has_dynamic_duo) return false;
		});
		load.all(() => {
			has_dynamic_duo = assign_elements();
			if (!has_dynamic_duo) return false;
		});
	},

};

export default module;
module.init();


/**
 * Auto-assign sequential trigger indices to elements within each duo
 * @param {NodeList} $duos
 */
function assign_triggers($duos) {
	$duos.forEach($duo => {
		const $content = $duo.querySelector('.dynamic-duo__content');
		if (!$content) return;
		const selector = $duo.getAttribute(selector_attr);
		$content.querySelectorAll(selector).forEach(($item, i) => {
			$item.setAttribute(trigger_attr, i + 1);
		});
	});
}


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_dynamic_duo) return true;

	const $duos = document.querySelectorAll(duo_$);
	if (!$duos.length) return false;

	assign_triggers($duos);

	// Hover on a trigger element (skip expandable triggers — those use toggle_start)
	document.addEventListener(g.mouse_enter_e, e => {
		if (!e.target.closest) return;
		const $trigger = e.target.closest(trigger_$);
		if (!$trigger) return;
		if ($trigger.querySelector('[aria-expanded]')) return;

		const $duo = $trigger.closest(duo_$);
		if (!$duo) return;

		activate_item($duo, $trigger.getAttribute(trigger_attr));
	}, true);

	// Expandable toggle (accordion open)
	document.addEventListener(events.expandable.toggle_start, e => {
		if (!e.detail || !e.detail.is_active) return;
		if (!e.target.closest) return;

		const $trigger = e.target.closest(trigger_$);
		if (!$trigger) return;

		const $duo = $trigger.closest(duo_$);
		if (!$duo) return;

		activate_item($duo, $trigger.getAttribute(trigger_attr));
	});

	return true;
}


/**
 * Activate image item by index
 * @param {Element} $duo - The dynamic-duo container
 * @param {string} index - The item index to activate
 */
function activate_item($duo, index) {
	$duo.querySelectorAll(item_$).forEach($item => {
		const is_match = $item.getAttribute(item_attr) === index;
		$item.setAttribute(g.is_active_attr, is_match ? g.true_s : g.false_s);
	});
}
